import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ajjjzem9b: FaireProductEntity = {
  token: "p_4ajjjzem9b",
  type: "product",
  name: "Soul Chai Rooibos Masala Chai Powder",
  brandToken: "b_wlog0i1yg7",
  brandName: "SØUL CHAI",
  imageUrl: "https://cdn.faire.com/fastly/d95a175f1c21ca82faf6928c10f005357f8593c89d09cf25b620546b123bf58d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f0a2833e4ca3468a127cc7f724e48f4430e00fea0241b1fb52ef5a28110bc75b.jpeg",
    "https://cdn.faire.com/fastly/72ddc49ba6eb2059c0bbfaac6e55fca85cc4144e09ecd4f60a917f8b7761f41b.jpeg",
    "https://cdn.faire.com/fastly/ddc7976c7a2c346384a98ca21555df9d42c3c3b9519652dccf54f70158188000.jpeg",
    "https://cdn.faire.com/fastly/00d94df0cb258ceb80544652de3204eb45f50878ddc486659bfe32d1a53e76fa.jpeg",
    "https://cdn.faire.com/fastly/050a2e6492a3a86e61612a6c97ac55c9f9bddf85955716ab1d1588814d0aa975.jpeg",
    "https://cdn.faire.com/fastly/15bb797871399063212b86d6e60758e90cd2232c80cc4f9c4d25c1bfb3cc4682.jpeg",
    "https://cdn.faire.com/fastly/25c8badd4197272944b19da8377d123802e275904bf8b2a3a375245e11ffe7b0.jpeg"
  ],
  priceDollars: 16.25,
  description: "Our vibrant, naturally caffeine-free Rooibos Masala Chai will bring soul to any day. Yes, even that day! It's strainer-free, got great mouthfeel and full of fresh, undiluted flavor~\n\n• Scoop a teaspoon of chai powder into your favorite mug,\n• add a dash of 205+ water,\n• fill the rest of your mug with steamed milk,\n• sweeten to your liking,\n• add a pinch of salt on top & enjoy!\n\n• Vegan & Gluten-free.\n\nIngredients: Rooibos, organic spices: ginger, cardamom, cinnamon, black pepper, cloves.",
  tags: [],
  msrpDollars: 24.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:34.823Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
